import { Baseball } from "sb-resp-ui";
/**
 * BaseballConstants defines constants related to baseball sport
 * @const array of displayed inning indexes
 * @const mapping of baseball types and components
 */
export const DisplayedBaseballInnings = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
export const ScoreboardTypes = {
    BaseballScoreboard: Baseball
};
export var ScoreboardType;
(function (ScoreboardType) {
    ScoreboardType["Default"] = "DefaultScoreboard";
    ScoreboardType["Baseball"] = "BaseballScoreboard";
})(ScoreboardType || (ScoreboardType = {}));
export var BaseballCurrentBattingTeam;
(function (BaseballCurrentBattingTeam) {
    BaseballCurrentBattingTeam[BaseballCurrentBattingTeam["Home"] = 1] = "Home";
    BaseballCurrentBattingTeam[BaseballCurrentBattingTeam["Away"] = 2] = "Away";
})(BaseballCurrentBattingTeam || (BaseballCurrentBattingTeam = {}));
//# sourceMappingURL=Constants.js.map